import { RoleGate } from "@/common/components/layout/RoleGate";
import { Plus } from "lucide-react";

const ACTION_ROLES = ["owner", "admin", "operator"] as const;

type Props = {
  count: number | null;
  onCreate: () => void;
};

export function LotsListHeader({ count, onCreate }: Props) {
  return (
    <header className="flex flex-col gap-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="font-medium text-3xl text-app-ink-1 tracking-tight">Lotes</h1>
          {count !== null && (
            <p className="mt-1 text-app-ink-3 text-sm">
              {count} {count === 1 ? "lote" : "lotes"}
            </p>
          )}
        </div>

        <RoleGate roles={[...ACTION_ROLES]}>
          <button
            type="button"
            onClick={onCreate}
            data-testid="lots-create-button"
            className="inline-flex items-center gap-2 rounded-2xl bg-app-ink-1 px-4 py-2.5 font-medium text-[14px] text-white transition-colors hover:bg-[#1e211d]"
          >
            <Plus size={16} strokeWidth={2} />
            <span className="hidden sm:inline">Crear lote</span>
            <span className="sm:hidden">Crear</span>
          </button>
        </RoleGate>
      </div>
    </header>
  );
}
